import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { setAccessTokenGetter } from "../api/client";
import { getAccessTokenOrLogout } from "./auth0Config";

export default function AuthBridge() {
  const { isAuthenticated, getAccessTokenSilently, logout } = useAuth0();

  useEffect(() => {
    if (!isAuthenticated) {
      setAccessTokenGetter(null);
      return;
    }
    setAccessTokenGetter(() => getAccessTokenOrLogout(getAccessTokenSilently, logout));
    return () => setAccessTokenGetter(null);
  }, [getAccessTokenSilently, isAuthenticated, logout]);

  return null;
}
